import React from "react";
import { Tabs, Tab, AppBar } from "@material-ui/core";
import TabPanel from "./CreateTabPanel";
import PropTypes from "prop-types";
import VideoLectureOrders from "./VideoLectureOrders";
import CourierDetails from "./CourierDetails";
import OnlineOrderTransaction from "./OnlineOrderTransaction";
import AuthWrapper from "../../../utils/AuthWrapper";

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const tabsNames = [
  {
    tabName: "order",
    tabId: "PROCESSING_ORDERS_ORDER",
  },
];
export default function ProcessingOrders({ inWallet }) {
  let tabsToShow = tabsNames?.filter((e, i) => {
    return AuthWrapper({ type: "TAB", name: e?.tabId, inBoolean: true });
  });
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let orderStatus = ["ORDER_ADDED"]

  const getTabPanel = (ele) => {
    let moduleToShow;
    switch (ele) {
      case "order":
        moduleToShow = <VideoLectureOrders orderStatus={orderStatus} />;
        break;
    }
    return moduleToShow;
  };
  return (
    <div>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          {tabsToShow?.map((ele, ind) => {
            return (
              <Tab
                style={{ textTransform: "capitalize" }}
                label={ele?.tabName}
                {...a11yProps(ind)}
              />
            );
          })}
        </Tabs>
      </AppBar>

      {tabsToShow?.map((ele, ind) => {
        return (
          <TabPanel value={value} index={ind}>
            {getTabPanel(ele?.tabName)}
          </TabPanel>
        );
      })}
    </div>
  );
}
